import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function PrimaryCTA({ to, children, className = "", testId, onClick, type }) {
  const cls = `group inline-flex items-center justify-center gap-2 rounded-full bg-[#1677FF] px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#0f5fe0] hover:shadow-[0_12px_30px_-10px_rgba(22,119,255,0.6)] ${className}`;
  const content = (
    <>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  if (type === "submit" || onClick) {
    return (
      <button type={type || "button"} onClick={onClick} className={cls} data-testid={testId}>
        {content}
      </button>
    );
  }
  return (
    <Link to={to} className={cls} data-testid={testId}>
      {content}
    </Link>
  );
}

export function SecondaryCTA({ to, children, className = "", testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2 rounded-full border border-[#111827]/15 bg-white px-7 py-3.5 text-sm font-semibold text-[#111827] transition-all duration-300 hover:border-[#1677FF] hover:text-[#1677FF] ${className}`}
    >
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </Link>
  );
}
